export const LOCAL_STORAGE_KEYS = {
  JWT_TOKEN: 'LLA_JWT_TOKEN',
  FILTERS: 'left_lane_filters'
}
